if (process.env.NODE_ENV !== 'development') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(new URL('/shared/service-worker.js', import.meta.url))
  }
}
